module.exports = __webpack_public_path__ + "static/iPhone13@1x-8028d9575e091f25f7b9bd67fe3a04d6.png";